import { createTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Theme {
    custom: {
      shadows: [string]
      contentMinWidth: number
      itemCard: {
        image: {
          width: number
          minWidth: number
        }
      }
      borderRadius: number
    }
  }
  interface ThemeOptions {
    custom?: {
      shadows?: [string]
      contentMinWidth?: number
      itemCard: {
        image: {
          width: number
        }
      }
      borderRadius?: number
    }
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#018B8F',
      '50': '#E1F4F1',
      '200': '#82DBD7',
      '300': '#4ABCB9',
      '400': '#19A3A3',
      '600': '#018B8F',
      '800': '#00605D',
      '900': '#024442',
      dark: '#024442',
      light: '#E1F4F1',
    },
    secondary: {
      main: '#868686',
    },
    error: {
      main: '#FF180D',
    },
    warning: {
      main: '#FFDC01',
    },
    info: {
      main: '#FFFFFF',
    },
    success: {
      main: '#13BF44',
      '50': '#E7F9EC',
      '200': '#DCF5E3',
      '400': '#B6EBC5',
      '900': '#09561F',
    },
    // text: {
    //   primary: '#000000',
    //   secondary: '#868686',
    //   disabled: '#D9D9D9',
    // },
  },
  typography: {
    fontFamily: "'Inter', 'sans-serif'",
    button: {
      textTransform: 'none',
    },
    fontWeightBold: 700,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 590,
      md: 1036,
      lg: 1296,
      xl: 1728,
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
})

theme.typography.h1 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
  fontSize: '36.62px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '29.30px',
  },
}

theme.typography.h2 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
  fontSize: '29.30px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '23.44px',
  },
}

theme.typography.h3 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
  fontSize: '23.44px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '18.75px',
  },
}

theme.typography.h4 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
  fontSize: '18.75px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '15px',
  },
}

theme.typography.h5 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
  fontSize: '15px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}

theme.typography.h6 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
  fontSize: '12px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '9.6px',
  },
}

theme.typography.body1 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '132.523%', // 19.878px
  fontSize: '18.75px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '15px',
  },
}

theme.typography.body2 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '132.523%', // 19.878px
  fontSize: '15px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}

theme.typography.subtitle1 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '132.523%', // 19.878px
  fontSize: '12px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '9.6px',
  },
}

theme.typography.subtitle2 = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '132.523%', // 19.878px
  fontSize: '9.6px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '7.68px',
  },
}

theme.custom = {
  shadows: [
    '0px 0px 4px rgba(0, 0, 0, 0.1)', // AppBar
  ],
  contentMinWidth: 320,
  itemCard: {
    image: {
      width: 100,
      minWidth: 100,
    },
  },
  borderRadius: 16,
  [theme.breakpoints.down('sm')]: {
    itemCard: {
      image: {
        width: 80,
        minWidth: 80,
      },
    },
    borderRadius: 12,
  },
}

// console.log('defaultTheme', theme)

export default theme
